import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home-experiences',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home-experiences.component.html',
  styleUrls: ['./home-experiences.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeExperiencesComponent {
  @Output() readMoreClicked = new EventEmitter<void>();
}
